module.exports = __webpack_public_path__ + "MI6dgjSRC-R9mVouC/pre-approval.png";